import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Theme from '../../Theme/index.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var HiddenCheckbox = styled.input.attrs(function (_props) {
  return {
    type: "checkbox"
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"])));
var Icon = styled.svg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  fill: none;\n  stroke: white;\n  stroke-width: 2px;\n"])));
var StyledCheckbox = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  margin: 0 5px 0 0;\n  cursor: pointer;\n  background: ", ";\n  border: 1px solid\n    ", ";\n  transition: all 150ms;\n  ", " {\n    visibility: ", ";\n  }\n"])), function (props) {
  return props.checked ? Theme.colors.lightBlue : "white";
}, function (props) {
  return props.checked ? Theme.colors.lightBlue : Theme.colors.pearlGrey;
}, Icon, function (props) {
  return props.checked ? "visible" : "hidden";
});
var CheckboxContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n"])));
var CheckBox = function CheckBox(_ref) {
  var checked = _ref.checked;
  return /*#__PURE__*/React__default.createElement(CheckboxContainer, null, /*#__PURE__*/React__default.createElement(HiddenCheckbox, {
    checked: checked,
    onChange: function onChange() {
      return null;
    }
  }), /*#__PURE__*/React__default.createElement(StyledCheckbox, {
    checked: checked
  }, /*#__PURE__*/React__default.createElement(Icon, {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }))));
};
CheckBox.displayName = "CheckBox";
CheckBox.propTypes = {
  checked: PropTypes.bool
};

export { StyledCheckbox, CheckBox as default };
